/**
 * Chip de gabinete — etiqueta corta de color que distingue a qué gabinete
 * pertenece un expediente, especialmente útil cuando una misma aseguradora
 * se tramita por varios gabinetes (p.ej. Mapfre por "Gefoex" vs Mapfre por
 * "GAB").
 *
 * Si el gabinete no tiene `short_label`, no renderiza nada.
 * El color (`bg`) viene del propio gabinete; si no lo tiene, gris neutro.
 * El texto se calcula automáticamente para contrastar (claro u oscuro).
 */
const FALLBACK_BG = "#E5E7EB";    // gris-200
const FALLBACK_FG = "#374151";    // gris-700

/** Devuelve `#ffffff` o `#111827` según el contraste necesario sobre `hex`. */
function textColorFor(hex) {
  if (!hex || !/^#[0-9A-Fa-f]{6}$/.test(hex)) return FALLBACK_FG;
  const r = parseInt(hex.slice(1, 3), 16);
  const g = parseInt(hex.slice(3, 5), 16);
  const b = parseInt(hex.slice(5, 7), 16);
  // Luminancia perceptual (W3C)
  const L = (0.299 * r + 0.587 * g + 0.114 * b) / 255;
  return L > 0.6 ? "#111827" : "#ffffff";
}

export function GabineteChip({ gabinete, size = "sm", className = "" }) {
  if (!gabinete || !gabinete.short_label) return null;
  const bg = gabinete.color || FALLBACK_BG;
  const fg = textColorFor(bg);
  const sizeCls =
    size === "xs" ? "text-[9px] px-1 py-[1px] tracking-tight"
    : size === "md" ? "text-[12px] px-2 py-0.5"
    : "text-[10px] px-1.5 py-[1px] tracking-wider";
  return (
    <span
      title={gabinete.name}
      data-testid={`gabinete-chip-${gabinete.id}`}
      className={`inline-flex items-center font-bold uppercase rounded ${sizeCls} ${className}`}
      style={{ backgroundColor: bg, color: fg }}
    >
      {gabinete.short_label}
    </span>
  );
}

export default GabineteChip;
